import axios from "axios";
import ContextService from "../../../services/ContextService";
import { extractTextFromPDF, extractTextFromWord, generateCopilotSummary } from "./CopilotFunction";
export async function CopilotExtractText(
  file: File,
  ContractType: string,
  AIProcess: string,
): Promise<any> {
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot") || "{}");
  const CopilotPAUrl = Copilot?.CopilotUrl;

  const accessToken = await fetchCopilotAccessToken(CopilotPAUrl);
  const conversationId = await getConversationID(accessToken);

  let textContent = "";
  //Extract text from the document
  if (file !== null && file.type === "application/pdf") {
    textContent = await extractTextFromPDF(file);
  } else if (
   file !== null && file.type ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    textContent = await extractTextFromWord(file);
  } else {
  }

  if (file !== null && !textContent?.trim()) {
    return "No meaningful content could be extracted from the document.";
  }
  let watermark: string | null = null;
  const generateCopilot = async (
    accessToken,
    conversationId,
    copilotPrompt
  ) => {
    try {
      // Send message to bot
      await axios.post(
        `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities`,
        copilotPrompt,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
        // Wait for the bot to respond (polling every 2s, max 30s)
      const maxAttempts = 30;
      let attempt = 0;

      while (attempt < maxAttempts) {
        await new Promise((res) => setTimeout(res, 2000));

        const { response: messages, hasMessages } = await fetchCopilotResponse(
          accessToken,
          conversationId
        );

        if (hasMessages && messages.length > 0) {
          const lastMessage = messages[messages.length - 1];
          const text = lastMessage?.text?.trim();
          // console.log(text,'response text')
          if (text) {
            return text;
          }
        }

        attempt++;
      }

      return "Timed out waiting for bot response";
    } catch (error) {
      console.error("Error in generateCopilot:", error);
      return "Failed to generate copilot";
    }
  };

  const fetchCopilotResponse = async (accessToken, conversationId) => {
    let botMessages = [];
    try {
      const botConversation = await getConversationMessages(
        accessToken,
        conversationId,
        watermark
      );
      botMessages =
        botConversation?.activities.filter(
          (activity: any) =>
            activity.from.id !== "user" && activity.text?.trim()
        ) || [];

      watermark = botConversation?.watermark;
      return { response: botMessages, hasMessages: botMessages.length > 0 };
    } catch (error) {
      console.error("Error fetching messages:", error);
      return { response: botMessages, hasMessages: false };
    }
  };



   function GetDocumentFields(sections) {
    const sectionKeys = Object.keys(sections);
    return sectionKeys.reduce((accumulator, key) => {
      accumulator.push(...sections[key].items);
      return accumulator;
    }, []);
  }
  if (AIProcess === "Copilot contract data fetch") {
    const allItems = GetDocumentFields(ContractType);
    const keys = allItems?.map(key => key.IntName) || [];
    const keysPrompt = keys.map(key => `Extract the value for "${key}":`).join("\n");
    const truncatedText = textContent;
    const userInput = `
        Given the following contract text, extract values for these keys: ${keysPrompt}.
 
        Return ONLY a raw JSON array of objects, formatted like:
        [
          { "key": "Title", "value": "..." },
          { "key": "Contract_Start_Date", "value": "..." }
        ]
        If a value is a date, format it as "MM/DD/YYYY". Do not include ordinal suffixes, and do not return natural language. Only use given format for dates.
        Omit keys not found. Do not include any explanation, markdown, or formatting—only the raw JSON.
    `;
 
    const instruction = `You are a legal assistant AI.
        User instruction: "${userInput?.trim()}"
        Use the contract text below to respond accurately and only based on the instruction.
        Contract Text: ${truncatedText}`.trim();
 
    const Copilotmessage = {
      type: "message",
      from: { id: "user", name: "You" },
      text: instruction.trim(),
      time: new Date().toISOString(),
    };
 
    const copilotResponseText = await generateCopilot(
      accessToken,
      conversationId,
      Copilotmessage
    );
    // console.log(copilotResponseText, "copilotResponseText")
 
    const keyValueArrayFormat = JSON.parse(copilotResponseText || "{}");
    const KeyValPairs = keyValueArrayFormat.reduce((acc, item) => {
      acc[item.key] = item?.value;
      return acc;
    }, {});
 
    return KeyValPairs
  }

  return null;
}

export async function fetchCopilotAccessToken(CopilotConfiguredPAUrl) {
  try {
    const response = await axios.post(
      CopilotConfiguredPAUrl,
      {
        QueryType: "GetToken",
      },
      {}
    );

    return response.data.token;
  } catch (error) {
    console.error("Error fetching token:", error);
    return null;
  }
}

export const getConversationID = async (accessToken) => {
  try {
    const response = await axios.post(
      `https://directline.botframework.com/v3/directline/conversations`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return response.data.conversationId;
  } catch (error) {
    console.error("Error starting conversation:", error);
    return null;
  }
};

export const getConversationMessages = async (
  directLineToken,
  conversationId,
  watermark
) => {
  try {
    const QueryURL = `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities${
      watermark ? `?watermark=${watermark}` : ""
    }`;
    const response = await axios.get(QueryURL, {
      headers: { Authorization: `Bearer ${directLineToken}` },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const postUserPromptText = async (
  userInput,
  conversationId,
  directLineToken,
) => {
  try {

    const message = {
      type: "message",
      from: { id: "user", name: "You" },
      text: userInput,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
    const response = await axios.post(
      `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities`,
      message,
      {
        headers: {
          Authorization: `Bearer ${directLineToken}`,
          // "Content-Type": "application/json",
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Error sending message:", error);
    return false;
  }
};

export async function uploadFilesInBatch(filesDataArray, folderName) {
  const documentLibraryName = "Apps365ChatbotDocs";
  const token = localStorage.getItem("CurrentToken");
  const siteUrl = localStorage.getItem("SiteURL");

  const siteRelativeUrl = new URL(siteUrl).pathname;

  const folderServerRelativeUrl = `${siteRelativeUrl}/${documentLibraryName}/${folderName}`;

  try {
    const createFolderUrl = `${ContextService.GetUrl()}/_api/web/folders`;
    const folderPayload = {
      "__metadata": { "type": "SP.Folder" },
      "ServerRelativeUrl": folderServerRelativeUrl
    };

    try {
      await axios.post(createFolderUrl, folderPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json;odata=verbose",
          "Content-Type": "application/json;odata=verbose"
        }
      });
      console.log("Folder created successfully:", folderServerRelativeUrl);
    } catch (err) {
      if (err.response?.status === 409) {
        console.log("Folder already exists:", folderServerRelativeUrl);
      } else {
        throw err;
      }
    }

    const uploadPromises = filesDataArray.map(async (file) => {
      const fileName = file?.name;
      const fileData = file?.file;

      const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderServerRelativeUrl}')/files/add(overwrite=true, url='${fileName}')`;

      try {
        const uploadResponse = await axios.post(uploadFileUrl, fileData, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/octet-stream"
          }
        });
        console.log(`File ${fileName} uploaded successfully:`, uploadResponse.data);
      } catch (error) {
        console.error(`Error uploading file ${fileName}:`, error);
      }
    });

    await Promise.all(uploadPromises);

  } catch (error) {
    console.error("Error in uploadFilesInBatch:", error);
  }
}
